import { Client } from "@xmpp/client"
import { getAllItems } from "./PubSub"
import { Element } from "@xmpp/xml"
import { wizardJid } from "../../jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import { captureError } from "../../ErrorHandlers"
import { RouteAlertConfig } from "../adHocCommands"

const NODE = "urn:slickshift:account:route-alert-config:0"

export type RouteAlertConfigWithJid = RouteAlertConfig & {
  jid: string
}

export const retrieveAllRouteAlertConfigs = async (
  xmpp: Client,
): Promise<RouteAlertConfigWithJid[]> => {
  const configs = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: NODE,
    timeout: 4000,
  })

  const items = configs
    .getChild("pubsub")
    ?.getChild("items")
    ?.getChildren("item") as [Element]

  if (!items) return []

  return items.map((item) => {
    const config = item.getChild("route-alert-config")

    return {
      jid: item.getAttr("id"),
      temperature_main_alert_level_min:
        config?.getAttr("temperature-main-alert-level-min") || undefined,
      temperature_main_alert_level_max:
        config?.getAttr("temperature-main-alert-level-max") || undefined,
      temperature_additional_alert_level_min:
        config?.getAttr("temperature-additional-alert-level-min") || undefined,
      temperature_additional_alert_level_max:
        config?.getAttr("temperature-additional-alert-level-max") || undefined,
    }
  })
}

export const subscribeToRouteAlertConfigs = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(client, wizardJid(client.jid!), NODE)
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      captureError(error, {
        origin: "XMPPOnOnline",
        extra: { message: "subscribeToRouteAlertConfigs" },
      })
    }
  }
}
